module.exports = __webpack_public_path__ + "media/images/favicon-16x16-aafa30934f68a8bd15eebe5873b824da.png";